import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'
import * as cc from 'currency-codes'

import LoadingProgress from '../components/LoadingProgress'
import ErrorMessage from '../components/ErrorMessage'

import { addContract } from '../actions/contracts'
import { fetchMachines, resetMachines } from '../actions/machines'
import { fetchCustomers } from '../actions/customers'

import { renderInputField, renderSelectField,
         renderTextAreaField } from '../utils/forms'
import { CONTRACT_TIMEZONES } from '../utils/timezones'
import '../styles/ContractDetailsView.css'

class ContractCreateForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }

    this.renderItems = this.renderItems.bind(this)
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { fetchMachines, fetchCustomers} = this.props

    fetchMachines()
    fetchCustomers()

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { machines, customers } = props

    if (!this.state.loaded &&
        machines && customers) {

      this.setState({
        loaded: true,
        fMachines: machines.filter(machine =>
          (machine.Customer === undefined) || (machine.Customer === null) || (!machine.Customer))
      })
    }
  }

  submit(props) {

    props.Executor = this.props.fullname

    return this.props.addContract(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  renderItems(props) {
    const { fields } = props

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Artículo</th>
                <th scope="col">Precio (PVP)</th>
                <th scope="col">Comisión Cliente (%)</th>
                <th scope="col">Stock</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((member, index) => (
                <tr key={index}>
                  <td>
                    <Field name={`${member}.item`}
                           component={renderSelectField}>
                      <option value="">Selecciona un artículo...</option>
                      <option value="VWPACK" key="VWPACK">PACK</option>
                      <option value="VWLAY" key="VWLAY">LAY</option>
                      <option value="VWGO" key="VWGO">GO</option>
                      <option value="LOCKERBASIC" key="LOCKERBASIC">LOCKERBASIC</option>
                      <option value="LOCKERBASICXL" key="LOCKERBASICXL">LOCKERBASICXL</option>
                      <option value="LOCKERCHARGER" key="LOCKERCHARGER">LOCKERCHARGER</option>
                      <option value="LOCKERCHARGERXL" key="LOCKERCHARGERXL">LOCKERCHARGERXL</option>
                      <option value="TUMBONAS" key="TUMBONAS">TUMBONAS</option>
                      <option value="FLOTADORES" key="FLOTADORES">FLOTADORES</option>
                      <option value="FLOTADORESHALFDAY" key="FLOTADORESHALFDAY">FLOTADORES MEDIO DIA</option>
                      <option value="FASTPASS" key="FASTPASS">FASTPASS</option>
                    </Field>
                  </td>
                  <td>
                    <Field
                      name={`${member}.price`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${member}.comission`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${member}.stock`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button className="btn btn-danger mr-1" type="button"
                             onClick={() => fields.remove(index)}>
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button className="btn bg-vw-light text-white" type="button"
                  onClick={() => fields.push({})}>
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { loaded, fMachines } = this.state
    const { customers, error, pristine, submitting, handleSubmit } = this.props

    if (!loaded) {
      return <LoadingProgress />
    }

    if (!customers || !fMachines) {
      return (
        <ErrorMessage
          message="No hay clientes o máquinas disponibles para nuevos contratos"/>
      )
    }

    return (
      <div className="contract-details-view">
        {/* Header Section */}
        <div className="ct-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-plus-circle"></i> NUEVO CONTRATO
              </h1>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit(this.submit)}>
          {/* Main Content Grid */}
          <div className="contract-content-grid">

            {/* Column 1 - Asignación */}
            <div className="contract-column">
              <div className="contract-card">
                <div className="card-header-custom bg-vw-dark">
                  <i className="fas fa-arrows-alt-h mr-2"></i>
                  Asignación
                </div>
                <div className="card-body-custom">
                  <Field name="Customer"
                        component={renderSelectField}
                        label="Cliente">
                    <option value="">Selecciona un cliente...</option>
                    {customers.map(customer => {
                      return (
                        <option value={customer._id} key={customer._id}>
                          {customer.Fullname}
                        </option>
                      )
                    })}
                  </Field>
                  <Field name="Machine"
                        component={renderSelectField}
                        label="Máquina">
                    <option value="">Selecciona una máquina...</option>
                    {fMachines.map(machine => {
                      return (
                        <option value={machine._id} key={machine._id}>
                          {machine.Serial}
                        </option>
                      )
                    })}
                  </Field>
                  <Field name="Location"
                        component={renderInputField}
                        type="text"
                        label="Localización (Lat, Lon)"/>
                  <Field name="TimeZone" component={renderSelectField} label="Zona horaria">
                    {CONTRACT_TIMEZONES.map(tz => (
                      <option value={tz.value} key={tz.value}>{tz.label}</option>
                    ))}
                  </Field>
                </div>
              </div>
            </div>

            {/* Column 2 - Funcionamiento */}
            <div className="contract-column">
              <div className="contract-card">
                <div className="card-header-custom bg-vw-light">
                  <i className="fas fa-cogs mr-2"></i>
                  Funcionamiento
                </div>
                <div className="card-body-custom">
                  <Field name="WorkingMode"
                         component={renderSelectField}
                         label="Working Mode">
                        <option value="">Selecciona un modo...</option>
                        <option value="0">WATERPROOF</option>
                        <option value="1">WATERPROOF + LOCKERS</option>
                  </Field>
                </div>
              </div>
            </div>

            {/* Column 3 - Condiciones */}
            <div className="contract-column">
              <div className="contract-card">
                <div className="card-header-custom bg-vw-dark">
                  <i className="fas fa-calendar-check mr-2"></i>
                  Condiciones
                </div>
                <div className="card-body-custom">
                  <Field name="StartDate"
                         component={renderInputField}
                         type="date"
                         label="Fecha inicio"/>
                  <Field name="EndDate"
                         component={renderInputField}
                         type="date"
                         label="Fecha fin"/>
                  <Field name="Currency"
                         component={renderSelectField}
                         value="EUR"
                         label="Moneda">
                    <option value="">Selecciona una moneda...</option>
                    {cc.codes().map(code => {
                      const name = cc.code(code).currency

                      return (
                        <option value={code} key={code}>
                          {`${code} - ${name}`}
                        </option>
                      )
                    })}
                  </Field>
                  <Field name="ConversionRate"
                         component={renderInputField}
                         type="text"
                         label="Tasa de conversión"/>
                  <Field name="ReportAE"
                        component={renderInputField}
                        type="checkbox"
                        label="Rerport AE Italia"/>
                </div>
              </div>
            </div>
          </div>

          {/* Ticket Card */}
          <div className="contract-card">
            <div className="card-header-custom bg-vw-light">
              <i className="fas fa-receipt mr-2"></i>
              Ticket
            </div>
            <div className="card-body-custom">
              <Field name="TicketHeader"
                     component={renderInputField}
                     type="text"
                     label="Cabecera"/>
              <Field name="TicketIVA"
                     component={renderInputField}
                     type="text"
                     label="IVA (%)"/>
              <Field name="TicketFooter"
                     component={renderInputField}
                     type="text"
                     label="Footer"/>
            </div>
          </div>

          {/* Artículos Card */}
          <div className="contract-card">
            <div className="card-header-custom bg-vw-dark">
              <i className="fas fa-shopping-cart mr-2"></i>
              Artículos
            </div>
            <div className="card-body-custom">
              <FieldArray name="Items" component={this.renderItems} />
            </div>
          </div>

          { error && <div className="alert alert-danger">{error}</div> }

          {/* Action Footer */}
          <div className="text-right mt-3">
            <Link to="/contracts" className="ct-admin-btn secondary mr-2">
              <i className="fas fa-times"></i>
              Cancelar
            </Link>
            <button className="ct-admin-btn primary save" type="submit"
                    disabled={pristine || submitting}>
              <i className="fas fa-save"></i>
              {submitting ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

ContractCreateForm = reduxForm({
  form: 'ContractCreateForm',
  initialValues: { TimeZone: 'Europe/Madrid' },
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/contracts`)
    props.resetMachines()
  },
  enableReinitialize: true
})(ContractCreateForm)

const mapStateToProps = state => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  addContract: bindActionCreators(addContract, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  resetMachines: bindActionCreators(resetMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ContractCreateForm)
